<p-dialog appendTo="body" [visible]="true" [modal]="true" [resizable]="false" [dismissableMask]="true" [closable]="false" position="center" [style]="{maxWidth: '95%'}">
    <p-header>{{ 'CASE_SENSITIVE.SET_ACCESS_TOKEN' | translate }}</p-header>

    <div id="api-key-dialog-container" style="flex-direction: column; align-items: flex-start">
        <span>{{ 'CASE_SENSITIVE.TURF_PRO_PAT' | translate }}</span>
        <input type="text" pInputText
                [(ngModel)]="apiKey"
                [size]="80"
                [placeholder]="'CASE_SENSITIVE.ENTER_TOKEN' | translate"
        />
    </div>

    <p-footer>
        <!-- Buttons will be laid out from right to left. First button listed will be at far right. -->
        <p-button type="button" [label]="'STRINGS.CANCEL' | translate" class="ui-button-secondary" (onClick)="onCancelDialog()"></p-button>
        <p-button type="button" [label]="'STRINGS.SAVE' | translate" (onClick)="onSetApiKey()"></p-button>
    </p-footer>
</p-dialog>
